import { render, staticRenderFns } from "./ability.vue?vue&type=template&id=c6af7684&scoped=true&"
import script from "./ability.vue?vue&type=script&lang=js&"
export * from "./ability.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6af7684",
  null
  
)

export default component.exports